import { Shield, ShieldCheck, ClipboardList, User } from 'lucide-react'
import type { UserRole } from '@common/permissions'
import { ROLE_LABELS } from '@common/permissions'
import { cn } from '@frontend/lib/utils'

const roleConfig: Record<UserRole, { icon: typeof Shield; classes: string }> = {
  owner: { icon: ShieldCheck, classes: 'bg-purple-50 text-purple-700 border-purple-200' },
  admin: { icon: Shield, classes: 'bg-blue-50 text-blue-700 border-blue-200' },
  manager: { icon: ClipboardList, classes: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  basic_user: { icon: User, classes: 'bg-slate-100 text-slate-600 border-slate-200' },
}

interface RoleBadgeProps {
  role: UserRole
  className?: string
}

export function RoleBadge({ role, className }: RoleBadgeProps) {
  const config = roleConfig[role]
  const Icon = config.icon

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 text-xs font-medium',
        config.classes,
        className
      )}
    >
      <Icon className="h-3 w-3" />
      {ROLE_LABELS[role]}
    </span>
  )
}
